import Deck from './Deck.jsx';

export default Deck;
